module.exports = __webpack_public_path__ + "static/media/VIP_Message_Icon@3x.66376d17.png";